/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Products_Leveling_Faq_Lapse_AInputs */



/**
* | output |
* | --- |
* | "They're kept but stop applying. Members keep the XP they earned and the default rules and curve take over, which can move levels up or down. Upgrading again ..." |
*
* @param {Products_Leveling_Faq_Lapse_AInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const products_leveling_faq_lapse_a = /** @type {((inputs?: Products_Leveling_Faq_Lapse_AInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Products_Leveling_Faq_Lapse_AInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Они сохранятся, но перестанут действовать. Участники сохранят заработанный XP, а дальше начнут действовать правила и кривая по умолчанию, из-за чего уровни могут сдвинуться вверх или вниз. Когда вы вернётесь на тариф, ваши правила снова заработают.")
	return /** @type {LocalizedString} */ ("They're kept but stop applying. Members keep the XP they earned and the default rules and curve take over, which can move levels up or down. Upgrading again brings your rules back.")
});